/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiApiSourceFromJSON, ApiApiSourceToJSON, } from './ApiApiSource';
import { ApiOAuthKeyFromJSON, ApiOAuthKeyToJSON, } from './ApiOAuthKey';
import { ApiOAuthTokenFromJSON, ApiOAuthTokenToJSON, } from './ApiOAuthToken';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiClientFromJSON(json) {
    return ApiClientFromJSONTyped(json, false);
}
export function ApiClientFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'abn': !exists(json, 'abn') ? undefined : json['abn'],
        'addedBy': !exists(json, 'addedBy') ? undefined : json['addedBy'],
        'apiSource': !exists(json, 'apiSource') ? undefined : ApiApiSourceFromJSON(json['apiSource']),
        'authId': !exists(json, 'authId') ? undefined : json['authId'],
        'billingAddress': !exists(json, 'billingAddress') ? undefined : json['billingAddress'],
        'businessName': !exists(json, 'businessName') ? undefined : json['businessName'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'hostName': !exists(json, 'hostName') ? undefined : json['hostName'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'invoiceAddressTo': !exists(json, 'invoiceAddressTo') ? undefined : json['invoiceAddressTo'],
        'ip': !exists(json, 'ip') ? undefined : json['ip'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'oauthKey': !exists(json, 'oauthKey') ? undefined : ApiOAuthKeyFromJSON(json['oauthKey']),
        'oauthToken': !exists(json, 'oauthToken') ? undefined : ApiOAuthTokenFromJSON(json['oauthToken']),
        'projects': !exists(json, 'projects') ? undefined : (json['projects'].map(ApiProjectFromJSON)),
        'pushedToDataflare': !exists(json, 'pushedToDataflare') ? undefined : json['pushedToDataflare'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'website': !exists(json, 'website') ? undefined : json['website'],
    };
}
export function ApiClientToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'abn': value.abn,
        'addedBy': value.addedBy,
        'apiSource': ApiApiSourceToJSON(value.apiSource),
        'authId': value.authId,
        'billingAddress': value.billingAddress,
        'businessName': value.businessName,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'firstName': value.firstName,
        'hostName': value.hostName,
        'id': value.id,
        'invoiceAddressTo': value.invoiceAddressTo,
        'ip': value.ip,
        'key': value.key,
        'lastName': value.lastName,
        'oauthKey': ApiOAuthKeyToJSON(value.oauthKey),
        'oauthToken': ApiOAuthTokenToJSON(value.oauthToken),
        'projects': value.projects === undefined ? undefined : (value.projects.map(ApiProjectToJSON)),
        'pushedToDataflare': value.pushedToDataflare,
        'timezone': value.timezone,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'website': value.website,
    };
}
